var _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuperstarsSide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 51,
    viewBox: "0 0 54 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "SUPERSTARS-side 1",
    clipPath: "url(#clip0_3756_2600)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3756_2600",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 54,
    height: 51
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clip0_3753_2480"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M54 0H0V51H54V0Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3756_2600)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SUPERSTARS-nav 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3756_2600",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 54,
    height: 51
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "clip0_15695_96060"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M54 0H0V51H54V0Z",
    fill: "white"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3756_2600)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 47.58C36.1944 47.58 45.08 38.6944 45.08 26.5C45.08 14.3055 36.1944 5.42 24 5.42C11.8055 5.42 2.92 14.3055 2.92 26.5C2.92 38.6944 11.8055 47.58 24 47.58ZM24 49.5C37.2548 49.5 47 39.7548 47 26.5C47 13.2452 37.2548 3.5 24 3.5C10.7451 3.5 1 13.2452 1 26.5C1 39.7548 10.7451 49.5 24 49.5Z",
    fill: "#4DBD94"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SUPERSTARS-nav"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Molecule / Avatar / Profile 123"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pro Badge"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4246 3.49738C34.7131 3.40397 36.9061 2.52172 38.6542 0.991565C39.7363 0.0443877 41.3227 0.0444861 42.4046 0.991813C44.1528 2.52239 46.3459 3.40495 48.6347 3.49849C49.9438 3.55197 51.1751 4.54544 51.3809 6.05746C51.4796 6.78365 51.5293 7.52323 51.5293 8.26939C51.5293 15.0857 47.3552 20.8869 41.5168 23.1C40.8792 23.3417 40.1789 23.3416 39.5413 23.0998C33.7035 20.8857 29.5293 15.0847 29.5293 8.26829C29.5293 7.51904 29.5801 6.78165 29.6779 6.05889C29.8825 4.54707 31.1132 3.55092 32.4246 3.49738ZM32.5221 6.05223C32.3229 6.06036 32.1532 6.20932 32.1255 6.41353C32.0435 7.01966 32.0009 7.63857 32.0009 8.26829C32.0009 13.9775 35.496 18.8423 40.3921 20.6992C40.4806 20.7328 40.578 20.7328 40.6666 20.6992C45.5626 18.8434 49.0578 13.9786 49.0578 8.26939C49.0578 7.64044 49.0159 7.02 48.9334 6.41391C48.9057 6.21002 48.7361 6.06146 48.5372 6.05333C45.6976 5.93729 42.9768 4.84241 40.808 2.94349C40.6475 2.80296 40.4112 2.80295 40.2506 2.94346C38.0818 4.84184 35.3613 5.93634 32.5221 6.05223Z",
    fill: "#1C2A34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1263 6.41382C32.1539 6.20961 32.3236 6.06066 32.5228 6.05253C35.3621 5.93663 38.0826 4.84214 40.2513 2.94375C40.4119 2.80324 40.6482 2.80326 40.8087 2.94379C42.9776 4.8427 45.6984 5.93759 48.5379 6.05362C48.7368 6.06175 48.9064 6.21031 48.9342 6.4142C49.0166 7.0203 49.0585 7.64074 49.0585 8.26969C49.0585 13.9789 45.5633 18.8436 40.6673 20.6995C40.5788 20.7331 40.4813 20.7331 40.3929 20.6995C35.4968 18.8426 32.0016 13.9777 32.0016 8.26858C32.0016 7.63886 32.0442 7.01995 32.1263 6.41382Z",
    fill: "#4DBD94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 46 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.7848 7.44336C34.0392 7.44336 34.2454 7.65671 34.2454 7.9199C34.2454 12.2931 36.6228 15.7275 40.2883 18.117C40.5035 18.2573 40.568 18.5515 40.4324 18.7742C40.2968 18.9969 40.0124 19.0636 39.7971 18.9233C35.945 16.4122 33.3241 12.7087 33.3241 7.9199C33.3241 7.65671 33.5304 7.44336 33.7848 7.44336Z",
    fill: "#F7FCFD",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 48 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.7926 4.5913C40.9889 4.75873 41.0168 5.05907 40.8549 5.26213C40.5074 5.69818 39.5168 6.58871 38.1438 6.92236C37.8961 6.98254 37.6482 6.82363 37.59 6.56742C37.5318 6.31121 37.6854 6.05472 37.9331 5.99454C39.072 5.71778 39.8976 4.96509 40.1441 4.65581C40.306 4.45275 40.5963 4.42387 40.7926 4.5913Z",
    fill: "#F7FCFD",
    fillOpacity: 0.8
  }))))))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3756_2600"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 51,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuperstarsSide);
export default __webpack_public_path__ + "static/media/SUPERSTARS-side.b93773225f90dc73cccc5526cb5c1850.svg";
export { ForwardRef as ReactComponent };